export default __webpack_public_path__ + "static/media/verified.ceb8a775.png";